<div class="card-grid">
  @for (card of cards; track card) {
  <button class="card" (click)="onCardSelected(card)">
    <app-img-card
      [backgroundColor]="card.backgroundColor"
      [title]="card.title"
      [subtitle]="card.subtitle"
      [imageUrl]="card.imageUrl"
      [tag]="card.tag"
      [tagColor]="card.tagColor"
    ></app-img-card>
  </button>
  }
</div>
@if (autoPaginate) {
<div class="card-grid-footer">
  <app-paginator
    [length]="length"
    [pageSize]="pageSize"
    (pageChanged)="onPageChanged($event)"
  ></app-paginator>
</div>
}
